import { IOPayload } from './io-payload';

export class DeviceInfo {
	Id: number;
	Name: string;
	Description: string;
	RootId: number;
	ParentId?: number;
	ModelId: number;
	SiteId: number;
	Serial: string;
	Keycode: string;
	BoardType: string;
	HwVersion: string;
	FwVersion: string;
	MappedId?: number;
	CrpAddress?: number;
	RemotesMax: number;
	RootSerial: string;
	InputId?: number;
	OutputId?: number;
	StateLabelActive?: string;
	StateLabelInactive?: string;
	StateActive?: number;
	CommandType?: number;
	CommandDuration?: number;
	CommandLabelActivate?: string;
	CommandLabelDeactivate?: string;
	CommandLabelTimed?: string;
	AllowedInputs?: number[];
	AllowedOutputs?: number[];
	Terminals?: IOPayload[];
	Operator?: string;
	Imei?: string;
	ConnType?: number;
}
